const merge = require('lodash.merge')
type FormattedQuery = { fragments: string; fields: string }

export function hashFromString(
  str: string,
  hash: Record<string, any> = {}
): Record<string, any> {
  let key = ''
  let exploded

  // return empty hash if no string passed
  if (str.length === 0) {
    return {}
  }

  exploded = str.split('.')
  key = exploded.shift() || ''
  str = exploded.join('.')

  if (str === '') {
    hash[key] = null
  } else {
    hash[key] = hashFromString(str, {})
  }

  return hash
}

export function hashFromStrings(strings: string[]): Record<string, any> {
  return strings
    .map(s => hashFromString(s))
    .reduce((acc, val) => merge(acc, val), {})
}

function formatRec(
  obj: Record<string, any>,
  fieldsConfig: Record<string, any>,
  curIndent: number,
  level: number = 0,
  indentIncrement: number = 2
): string {
  const newIndent = curIndent + level * indentIncrement
  const space = ' '.repeat(newIndent)
  const fields: string[] = []

  for (let [k, v] of Object.entries(obj)) {
    // handle abstract types (interfaces/unions) and fragments
    if (k.startsWith('on:')) {
      k = k.replace('on:', '... on ')
    } else if (k.startsWith('fragment:')) {
      const fragmentName = k.replace('fragment:', '')
      k = `...${fragmentName}`
    }

    const res =
      v === null
        ? `${space}${k}`
        : `${space}${k} {\n${formatRec(
            v,
            fieldsConfig,
            curIndent,
            level + 1
          )}\n${space}}`

    fields.push(res)
  }

  return fields.join('\n')
}

export default function format(
  fields: string[],
  fieldsConfig: Record<string, object> = { fragmentDefinitions: {} },
  startIndent: number = 6
): FormattedQuery {
  let allFragments = ''
  const { fragmentDefinitions } = fieldsConfig
  const space = ' '.repeat(startIndent)

  for (const [name, value] of Object.entries(fragmentDefinitions)) {
    if (value.on) {
      allFragments += `${space}fragment ${name} on ${value.on} {\n${formatRec(
        hashFromStrings(value.fragment),
        { fragmentDefinitions: {} },
        startIndent + 2
      )}\n${space}}\n`
    } else {
      allFragments += value.fragment
    }
  }

  return {
    fragments: allFragments,
    fields: formatRec(hashFromStrings(fields), fieldsConfig, startIndent),
  }
}
